"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dtoGetterSetterValidationHelper = void 0;
var faker_1 = require("@faker-js/faker");
var convertObjectPropertyToGetterAndSetterName_1 = require("../utils/convertObjectPropertyToGetterAndSetterName");
var dtoGetterSetterValidationHelper = function (dto, payload) {
    for (var _i = 0, _a = Object.keys(payload); _i < _a.length; _i++) {
        var propertyKey = _a[_i];
        var _b = (0, convertObjectPropertyToGetterAndSetterName_1.convertObjectPropertyToGetterAndSetterName)(propertyKey), getterMethodName = _b.getterMethodName, setterMethodName = _b.setterMethodName;
        var getter = Reflect.get(dto.source, getterMethodName);
        var setter = Reflect.get(dto.source, setterMethodName);
        expect(getter()).toEqual(payload[propertyKey]);
        var updatedPropertyBySetter = void 0;
        updatedPropertyBySetter = "".concat(new Date()
            .toISOString()
            .toString(), "_").concat(faker_1.faker.datatype.uuid(), "_").concat(faker_1.faker.datatype
            .bigInt()
            .toString());
        if (typeof payload[propertyKey] === 'number') {
            updatedPropertyBySetter = faker_1.faker.datatype.number();
        }
        else if (Array.isArray(payload[propertyKey])) {
            updatedPropertyBySetter = [updatedPropertyBySetter];
        }
        setter(updatedPropertyBySetter);
        expect(getter()).toEqual(updatedPropertyBySetter);
        var serializedProperty = Reflect.get(dto.toJSON(), propertyKey);
        expect(serializedProperty).toEqual(updatedPropertyBySetter);
    }
    return true;
};
exports.dtoGetterSetterValidationHelper = dtoGetterSetterValidationHelper;
